import React, { useState, useContext } from 'react';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import SiteContext from 'components/shared/siteContext/siteContext';
import Heading from 'components/common/heading/heading';
import useAsyncEffect from 'use-async-effect';
import BackofficeReportsService from 'services/backofficeReportsService';
import BackofficeReportsHelper from 'components/navigation/backofficeReports/backofficeReportsHelper';
import { useHistory } from 'hooks/router';
import FlexibleRow from 'components/common/flexibleRow/flexibleRow';
import AppContext from 'contexts/appContext';
import Panel from 'components/common/panel/panel';

export default function BackofficeReportsStoreTasksPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const [hierarchyId, setHierarchyId] = useState();
  const [taskList, setTaskList] = useState();
  const history = useHistory();

  useAsyncEffect(async () => {
    setAppArea(AppContext.Areas.BackofficeReports, 'Task List');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Backoffice Reports', href: '/BackofficeReports/Run' }, { name: 'Tasks', selected: true }]);

    setHierarchyId(await BackofficeReportsHelper.getSiteContextHierarchy());
    setTaskList(await BackofficeReportsService.API.getStoreTasks(await BackofficeReportsHelper.getSiteContextHierarchy()));
  }, [hierarchyId]);

  const handleSelectSite = (id) => {
    BackofficeReportsHelper.setSiteContextHierarchy(id);
    setHierarchyId(id);
  };

  const renderRows = () => {
    if (!taskList || taskList.length === 0) {
      return <div>No tasks found.</div>;
    }
    return taskList.map((item, index) => <TaskRow data={item} index={index} history={history} key={index} />);
  };

  if (!taskList) {
    //Loading View
    return (
      <>
        <Heading />

        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <Panel>
              <Panel.SkeletonHeader width={200} />
              <Panel.SkeletonBody rows={10} rowHeight={24} rowMargin={20} />
            </Panel>
          </div>
        </div>
      </>
    );
  }

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button loaded={hierarchyId ? true : false} hierarchyId={hierarchyId} onSelectSite={handleSelectSite} selectableFn={BackofficeReportsHelper.siteFilterFn} />
          <div className='flex-grow-1 d-flex justify-content-end'>
            <Inputs.Button variant='primary' href='/BackofficeReports/Task/Create' iconClass='icons8-plus-math' label='Create Task' />
          </div>
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <Panel>
              <Panel.Header>Tasks</Panel.Header>
              <Panel.Body>
                <ul className='list-group list-group-flush'>
                  {renderRows()}
                </ul>
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function TaskRow(props) {
  const data = props.data;

  return (
    <a href={`/BackofficeReports/Task/${data.taskId}`} className='list-group-item list-group-item-action' key={data.taskId}>
      <div>
        <FlexibleRow>
          <FlexibleRow.Stackable at='lg' width='50%'>
            <FlexibleRow.Column width='50%' className='premier'>
              {data.taskName}
            </FlexibleRow.Column>
            <FlexibleRow.Column width='50%'>
              {data.reportName}
            </FlexibleRow.Column>
          </FlexibleRow.Stackable>
          <FlexibleRow.Stackable width='30%'>
            <FlexibleRow.Column className='subtle'>
              {data.dateDescription}
            </FlexibleRow.Column>
          </FlexibleRow.Stackable>
          <FlexibleRow.Stackable at='none' width='20%'>
            <div className='w-100 mr-2 text-right' style={{ fontSize: '21px', lineHeight: '21px' }}>
              {data.isDistributed ? <i className='icons8-envelope ml-2' /> : null}
              {data.isScheduled ? <i className='icons8-clock ml-2' /> : null}
            </div>
          </FlexibleRow.Stackable>
        </FlexibleRow>
      </div>
    </a>
  );
}